var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M16.6 8.6L12 13.2 7.4 8.6 6 10l6 6 6-6-1.4-1.4z"}})}
var staticRenderFns = []

export { render, staticRenderFns }